import React from 'react';
import { FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';
import { statusMeta, timeAgo } from '../monitoringUtils';

// Feed of recent environmental alerts, with optional resolve action.
export default function AlertFeed({ alerts, onResolve, showDevice = false, emptyText = 'No alerts.' }) {
  if (!alerts?.length) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-gray-400">
        <FaCheckCircle className="text-2xl mb-2 text-green-400" />
        <p className="text-sm">{emptyText}</p>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-gray-100">
      {alerts.map((a) => {
        const meta = statusMeta(a.level);
        return (
          <li key={a._id} className="py-3 flex items-start gap-3">
            <span className={`mt-0.5 ${meta.text}`}>
              <FaExclamationTriangle />
            </span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className={`text-xs font-semibold uppercase ${meta.text}`}>{a.level}</span>
                {showDevice && (
                  <span className="text-xs text-gray-500">
                    {a.device?.houseName || a.deviceId}
                  </span>
                )}
                <span className="text-xs text-gray-400">· {timeAgo(a.createdAt)}</span>
              </div>
              <p className="text-sm text-gray-700 break-words">{a.message}</p>
            </div>
            {a.status === 'active' && onResolve && (
              <button
                onClick={() => onResolve(a)}
                className="text-xs px-2 py-1 rounded border border-gray-200 text-gray-600 hover:bg-gray-50 whitespace-nowrap"
              >
                Resolve
              </button>
            )}
            {a.status === 'resolved' && (
              <span className="text-xs text-green-600 whitespace-nowrap">Resolved</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
